import { Article } from "@faire/help-center-utils/articles";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { trackCxFoundationsHcArticleFromContactUsClick } from "@faire/web-api--source/events/cxFoundations/click/hcArticleFromContactUs";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

export const SuggestedArticle: React.FC<Article> = ({
  id,
  name,
  getPreview,
  getLink,
}) => {
  const [preview, setPreview] = useState("");

  useEffect(() => {
    async function fetchData() {
      const response = await getPreview();
      setPreview(response ?? "");
    }
    fetchData();
  }, [getPreview]);

  const trackClickOnArticle = () => {
    trackCxFoundationsHcArticleFromContactUsClick(id, name);
  };

  return (
    <Column align="flex-start">
      <Button
        variant="tertiary"
        linkTo={getLink()}
        onClick={trackClickOnArticle}
        target="__blank"
      >
        <Typography variant="paragraphSansRegular">{name}</Typography>
      </Button>
      <Spacer height="1x" />
      <PreviewContainer>
        <Typography variant="labelSansRegular">{preview}</Typography>
      </PreviewContainer>
    </Column>
  );
};

const PreviewContainer = styled.div`
  display: -webkit-box;
  width: 100%;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
